import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({

    sessionContainer: {

        display: "flex",
        height: "80%",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",


    }

}));

export { useStyles };